import { useState } from 'react';

import { useRouter } from 'expo-router';

import { IRestaurant } from '@rbi-ctg/store';
import { ServiceMode, useOrderContext } from 'state/order';
import { routes } from 'utils/routing';

export const useDialogActions = (onClose?: () => void, availableRestaurant?: IRestaurant) => {
  const { navigate, setParams } = useRouter();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { selectStore } = useOrderContext();

  const selectNearbyStore = async () => {
    if (!availableRestaurant?._id) {
      return;
    }

    await selectStore(
      availableRestaurant,
      () => setIsDialogOpen(false),
      ServiceMode.DRIVE_THRU,
      false,
      true
    );
  };

  const chooseAnotherStore = () => {
    navigate(routes.storeLocator);
    setIsDialogOpen(false);
    setParams({ redirectTo: routes.cart });
    onClose?.();
  };

  return {
    isDialogOpen,
    setIsDialogOpen,
    availableRestaurant,
    selectNearbyStore,
    chooseAnotherStore,
  };
};
